import {getMaterial} from "@project/sdk/engineering";
import {GetMaterialResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {materialKeys} from "../../../material-keys";

export function getMaterialQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...materialKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetMaterialResponse.parse(await getMaterial(id, {includeDeleted}, {signal})),
  });
}
